import { Directive, computed, input } from '@angular/core'

import { hlm } from '@spartan-ng/brain/core'

import { provideHlmIconConfig } from '@yoshu-lib/ui/ui-icon-helm/src'

import type { ClassValue } from 'clsx'

@Directive({
  selector: '[hlmMenuIcon]',
  standalone: true,
  providers: [provideHlmIconConfig({ size: 'sm' })],
  host: {
    '[class]': '_computedClass()'
  }
})
export class HlmMenuItemIconDirective {
  public readonly userClass = input<ClassValue>('', { alias: 'class' })
  protected _computedClass = computed(() => hlm('mr-2', this.userClass()))
}
